// Anonymous client-generated ID, persisted to IndexedDB.
//
// Phase 4 contract: this id is an *identifier*, so it must NOT be generated or
// stored before consent. The only caller is `bootstrapIdentity`, which runs
// exclusively on consent acceptance — do not call `getAnonymousId()` from page
// load or any pre-consent path. (This supersedes the Phase 3 "local-only, fine
// before consent" justification that previously lived in shell/App.tsx.)

import { getMeta, setMeta } from "../store/db";

const META_KEY = "anonymous_id";

function generate(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  // Fallback for older test environments.
  const buf = new Uint8Array(16);
  for (let i = 0; i < 16; i++) buf[i] = Math.floor(Math.random() * 256);
  return Array.from(buf, (b) => b.toString(16).padStart(2, "0")).join("");
}

export async function getAnonymousId(): Promise<string> {
  const cur = await getMeta(META_KEY);
  if (typeof cur === "string" && cur.length > 0) return cur;
  const fresh = generate();
  await setMeta(META_KEY, fresh);
  return fresh;
}

export async function forgetAnonymousId(): Promise<void> {
  // Overwrite with empty rather than delete so the next read regenerates a
  // brand-new id rather than picking up whatever was there before.
  await setMeta(META_KEY, "");
}
